import { render, staticRenderFns } from "./DetailEnseigne.vue?vue&type=template&id=ad97c3bc"
import script from "./DetailEnseigne.vue?vue&type=script&lang=js"
export * from "./DetailEnseigne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports